<template>
    <Breadcrumbs main="Ui Kits" title="Accordion" />
    <div class="container-fluid ui-accordion">
        <div class="row">
            <simpleAccordion />
            <flushAccordion />
            <multipleAccordion />
            <iconsAccordion />
            <outlineAccordion />
            <horizontalAccordion />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const simpleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/simpleAccordion.vue"))
const flushAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/flushAccordion.vue"))
const multipleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/multipleAccordion.vue"))
const iconsAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/iconsAccordion.vue"))
const outlineAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/outlineAccordion.vue"))
const horizontalAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/horizontalAccordion.vue"))
</script>